export const APPLIQUE_PRINT_TYPE_ID = 5;
export const WOVEN_TAGS_VARIANT_ID = 3;

export const STREAMLINE_PRINT_TYPES = [
  {
    type: 'Screen Print',
    className: 'screen-print',
    id: 1,
    variants: [
      {
        id: 1,
        type: 'standard',
        label: 'Standard',
        imageSrc: '/src/assets/svg/print-types/screen-print/standard.svg',
        sImageSrc: '/src/assets/svg/print-types/screen-print/standard.png',
      },
      {
        id: 2,
        type: 'puffInk',
        label: 'Puff Ink',
        imageSrc: '/src/assets/svg/print-types/screen-print/puff.png',
        sImageSrc: '/src/assets/svg/print-types/screen-print/puff.png',
      },
      {
        id: 3,
        type: 'neonInk',
        label: 'Neon Ink',
        imageSrc: '/src/assets/svg/print-types/screen-print/neon.png',
        sImageSrc: '/src/assets/svg/print-types/screen-print/neon.png',
      },
      {
        id: 4,
        type: 'metallicAndGlitterInk',
        label: 'Metallic & Glitter Ink',
        imageSrc: '/src/assets/svg/print-types/screen-print/metallic.png',
        sImageSrc: '/src/assets/svg/print-types/screen-print/metallic.png',
      },
      {
        id: 5,
        type: 'glowInTheDarkInk',
        label: 'Glow in the dark Ink',
        imageSrc: '/src/assets/svg/print-types/screen-print/glow.png',
        sImageSrc: '/src/assets/svg/print-types/screen-print/glow.png',
      },
      {
        id: 6,
        type: 'waterBasedInk',
        label: 'Water based Ink',
        imageSrc: '/src/assets/svg/print-types/screen-print/water.png',
        sImageSrc: '/src/assets/svg/print-types/screen-print/water.png',
      },
    ],
  },
  {
    type: 'Digital',
    className: 'digital-print',
    id: 2,
    variants: [
      {
        id: 1,
        type: 'digitalPrinting',
        label: 'Digital Printing',
        imageSrc: '/src/assets/svg/print-types/digital/standard.png',
        sImageSrc: '/src/assets/svg/print-types/digital/standard.png',
      },
    ],
  },
  {
    type: 'Embroidery',
    className: 'embroidery',
    id: 3,
    variants: [
      {
        id: 1,
        type: 'standard',
        label: 'Standard',
        imageSrc: '/src/assets/svg/print-types/emb/standard.png',
        sImageSrc: '/src/assets/svg/print-types/emb/standard.png',
      },
      {
        id: 2,
        type: 'puff',
        label: 'Puff',
        imageSrc: '/src/assets/svg/print-types/emb/puff.png',
        sImageSrc: '/src/assets/svg/print-types/emb/puff.png',
      },
      {
        id: 3,
        type: 'metallic&Glitter',
        label: 'Metallic & Glitter',
        imageSrc: '/src/assets/svg/print-types/emb/metallic.png',
        sImageSrc: '/src/assets/svg/print-types/emb/metallic.png',
      },
    ],
  },
  {
    type: 'Applique',
    className: 'applique',
    id: 5,
    variants: [
      {
        id: 1,
        type: 'standard',
        label: 'Standard',
        imageSrc: '/src/assets/svg/print-types/applique/standard.png',
        sImageSrc: '/src/assets/svg/print-types/applique/standard.png',
      },
      {
        id: 2,
        type: 'sublimatedAppliqueEmbroidery',
        label: 'Sublimated Applique Embroidery',
        imageSrc: '/src/assets/svg/print-types/applique/sublimated.png',
        sImageSrc: '/src/assets/svg/print-types/applique/sublimated.png',
      },
      {
        id: 3,
        type: 'wovenTags',
        label: 'Woven Tags',
        imageSrc: '/src/assets/svg/print-types/applique/woven.jpeg',
        sImageSrc: '/src/assets/svg/print-types/applique/woven.jpeg',
      },
    ],
  },
  {
    type: 'Transfers',
    className: 'transfers',
    id: 6,
    variants: [
      {
        id: 1,
        type: 'directToFilm',
        label: 'Direct-to-film',
        imageSrc: '/src/assets/svg/print-types/transfers/direct-film.png',
        sImageSrc: '/src/assets/svg/print-types/transfers/direct-film.png',
      },
      {
        id: 2,
        type: 'supacolor',
        label: 'Supacolor',
        imageSrc: '/src/assets/svg/print-types/transfers/supacolor.png',
        sImageSrc: '/src/assets/svg/print-types/transfers/supacolor.png',
      },
      {
        id: 3,
        type: 'screenPrintTransfer',
        label: 'Screen Print Transfer',
        imageSrc: '/src/assets/svg/print-types/transfers/screen-print-transfer.png',
        sImageSrc: '/src/assets/svg/print-types/transfers/screen-print-transfer.png',
      },
    ],
  },
  {
    type: 'Patches',
    className: 'patches',
    id: 10,
    variants: [
      {
        id: 1,
        type: 'applique',
        label: 'Applique',
        imageSrc: '/src/assets/svg/print-types/patches/applique.png',
        sImageSrc: '/src/assets/svg/print-types/patches/applique.png',
      },
      {
        id: 4,
        type: 'chenille',
        label: 'Chenille',
        imageSrc: '/src/assets/svg/print-types/patches/chenille.png',
        sImageSrc: '/src/assets/svg/print-types/patches/chenille.png',
      },
      {
        id: 2,
        type: 'sublimated',
        label: 'Sublimated',
        imageSrc: '/src/assets/svg/print-types/patches/sublimated.png',
        sImageSrc: '/src/assets/svg/print-types/patches/sublimated.png',
      },
      {
        id: 3,
        type: 'woven',
        label: 'Woven',
        imageSrc: '/src/assets/svg/print-types/patches/woven.png',
        sImageSrc: '/src/assets/svg/print-types/patches/woven.png',
      },
      {
        id: 5,
        type: 'fauxLeather',
        label: 'Faux Leather',
        imageSrc: '/src/assets/svg/print-types/patches/faux.png',
        sImageSrc: '/src/assets/svg/print-types/patches/faux.png',
      },
      {
        id: 6,
        type: 'genuineLeather',
        label: 'Genuine Leather',
        imageSrc: '/src/assets/svg/print-types/patches/leather.png',
        sImageSrc: '/src/assets/svg/print-types/patches/leather.png',
      },
      {
        id: 7,
        type: 'rubber',
        label: 'Rubber',
        imageSrc: '/src/assets/svg/print-types/patches/rubber.png',
        sImageSrc: '/src/assets/svg/print-types/patches/rubber.png',
      },
    ],
  },
  {
    type: 'Rhinestones',
    className: 'rhinestones',
    id: 8,
    variants: [
      {
        id: 1,
        type: 'rhinestones',
        label: 'Rhinestones',
        imageSrc: '/src/assets/svg/print-types/rhinestones/rhinestones.png',
        sImageSrc: '/src/assets/svg/print-types/rhinestones/rhinestones.png',
      },
    ],
  },
  {
    type: 'Vinyl',
    className: 'vinyl',
    id: 7,
    variants: [
      {
        id: 1,
        type: 'standard',
        label: 'Standard',
        imageSrc: '/src/assets/svg/print-types/vinyl/standard.png',
        sImageSrc: '/src/assets/svg/print-types/vinyl/standard.png',
      },
      {
        id: 2,
        type: 'flock',
        label: 'Flock',
        imageSrc: '/src/assets/svg/print-types/vinyl/flock.png',
        sImageSrc: '/src/assets/svg/print-types/vinyl/flock.png',
      },
      {
        id: 3,
        type: 'glitter',
        label: 'Glitter',
        imageSrc: '/src/assets/svg/print-types/vinyl/glitter.png',
        sImageSrc: '/src/assets/svg/print-types/vinyl/glitter.png',
      },
      {
        id: 4,
        type: 'holographic',
        label: 'Holographic',
        imageSrc: '/src/assets/svg/print-types/vinyl/holographic.png',
        sImageSrc: '/src/assets/svg/print-types/vinyl/holographic.png',
      },
      {
        id: 5,
        type: 'leather',
        label: 'Leather',
        imageSrc: '/src/assets/svg/print-types/vinyl/leather.png',
        sImageSrc: '/src/assets/svg/print-types/vinyl/leather.png',
      },
    ],
  },
  {
    type: 'Foil',
    className: 'foil',
    id: 9,
    variants: [
      {
        id: 1,
        type: 'standard',
        label: 'Standard',
        imageSrc: '/src/assets/svg/print-types/foil/standard.png',
        sImageSrc: '/src/assets/svg/print-types/foil/standard.png',
      },
    ],
  },
  {
    type: 'Engraving',
    className: 'engraving',
    id: 12,
    variants: [
      {
        id: 1,
        type: 'laserEtch',
        label: 'Laser Etch',
        imageSrc: '/src/assets/svg/print-types/engraving/laser-etch.png',
        sImageSrc: '/src/assets/svg/print-types/engraving/laser-etch.png',
      },
    ],
  },
  {
    type: 'Sublimation',
    className: 'sublimation',
    id: 13,
    variants: [
      {
        id: 1,
        type: 'sublimation',
        label: 'Sublimation',
        imageSrc: '/src/assets/svg/print-types/sublimation/sublimation.png',
        sImageSrc: '/src/assets/svg/print-types/sublimation/sublimation.png',
      },
    ],
  },
];

export const OLD_PRINT_TYPES = [
  {
    id: 1,
    type: 'Screen Print',
    imageSrc: '/src/assets/svg/print-types/screen-print/standard.svg',
    sImageSrc: '/src/assets/svg/print-types/screen-print/standard.png',
    variant: 'Standard',
  },
  {
    id: 2,
    type: 'Digital Print',
    imageSrc: '/src/assets/svg/print-types/digital/standard.png',
    sImageSrc: '/src/assets/svg/print-types/digital/standard.png',
    variant: 'Standard',
  },
  {
    id: 3,
    type: 'Embroidery',
    imageSrc: '/src/assets/svg/print-types/emb/standard.png',
    sImageSrc: '/src/assets/svg/print-types/emb/standard.png',
    variant: 'Standard',
  },
  {
    id: 5,
    type: 'Applique',
    imageSrc: '/src/assets/svg/print-types/applique/standard.png',
    sImageSrc: '/src/assets/svg/print-types/applique/standard.png',
    variant: 'Standard',
  },
  {
    id: 6,
    type: 'Chenille',
    imageSrc: '/src/assets/svg/print-decor-types/chenille.png',
    sImageSrc: '/src/assets/svg/print-decor-types/chenille.png',
    variant: 'Standard',
  },
  {
    id: 7,
    type: 'DTF/SupaColor',
    imageSrc: '/src/assets/svg/print-decor-types/direct-film.png',
    sImageSrc: '/src/assets/svg/print-decor-types/direct-film.png',
    variant: 'Standard',
  },
  {
    id: 8,
    type: 'Puff Ink',
    imageSrc: '/src/assets/svg/print-decor-types/puff.png',
    sImageSrc: '/src/assets/svg/print-decor-types/puff.png',
    variant: 'Standard',
  },
  {
    id: 9,
    type: 'Sublimated Patch',
    imageSrc: '/src/assets/svg/print-decor-types/sublimated.png',
    sImageSrc: '/src/assets/svg/print-decor-types/sublimated.png',
    variant: 'Standard',
  },
  {
    id: 10,
    type: 'Leather Vinyl',
    imageSrc: '/src/assets/svg/print-decor-types/leather.png',
    sImageSrc: '/src/assets/svg/print-decor-types/leather.png',
    variant: 'Standard',
  },
  {
    id: 11,
    type: 'Heat Press Vinyl',
    imageSrc: '/src/assets/svg/print-decor-types/heat-press.png',
    sImageSrc: '/src/assets/svg/print-decor-types/heat-press.png',
    variant: 'Standard',
  },
  {
    id: 12,
    type: 'Flock',
    imageSrc: '/src/assets/svg/print-decor-types/flock.png',
    sImageSrc: '/src/assets/svg/print-decor-types/flock.png',
    variant: 'Standard',
  },
];
